<template>
  <div>
    <Row type="flex" justify="end" class="code-row-bg">
      <Button class="add_item" icon="md-add" type="primary" @click="modal=true">添加章节</Button>
      <Button class="add_item" @click="papersBooksDotted" type="primary">打印铺码</Button>
      <Button
        class="add_item"
        @click.capture="printBooksDotted('all')"
        data-context="all"
        type="primary"
      >印刷铺码</Button>
      <!--<span class="ctrl_btn"  v-clipboard:copy="copyUrl" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">下载</span>-->
      <!-- <Button class="add_item" @click="downPapersBooksDotted" type="primary">下载铺码PDF</Button> -->
      <!-- <Button class="add_item" @click="papersBooksBoxesPdf" type="primary">生成校对PDF</Button>
      <Button
        class="add_item"
        @click="downBoxedFile"
        :disabled="param.boxedFile?false:true"
        type="primary"
      >下载校对PDF</Button>-->
    </Row>
    <div class="table">
      <Table border :columns="tables" :data="tableData" ref="table">
        <template slot-scope="{row}" slot="printFlag">
          <span class="ctrl_btn" v-if="row.printFlag == 0">待铺码</span>
          <span class="ctrl_btn" v-else-if="row.printFlag == 1">铺码申请中</span>
          <span class="ctrl_btn" v-else-if="row.printFlag == 3 || row.printFlag == 8">铺码中</span>
          <span class="ctrl_btn" v-else-if="row.printFlag == 9">铺码失败</span>
          <a
            :href="copyUrl+'/paper/'+row.printFile"
            :download="copyUrl+'/paper/'+row.printFile"
            target="_blank"
            class="ctrl_btn"
            v-else
          >下载</a>
          <!--<span class="ctrl_btn" v-else v-clipboard:copy="copyUrl+'/paper/'+row.printFile" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制链接</span>-->
        </template>
      </Table>
    </div>
    <Page :total="page.page*10" :current="page.current" @on-change="handlePage" />
    <Modal v-model="modal" title="添加章节" @on-ok="ok" ok-text="下一步" @on-cancel="cancel" width="332">
      <div class="model_box">
        <Input v-model="name" placeholder="请输入章节名称" style="width: 300px;" />
        <Input v-model="seqno" type="number" placeholder="请输入章节序号" style="width: 300px" />
        <div style="width:100%;">
          <span style="margin-right:10px;">小题排序</span>
          <RadioGroup v-model="radioValue">
            <Radio label="每道大题重新排列"></Radio>
            <Radio label="连续排序"></Radio>
          </RadioGroup>
        </div>
      </div>
    </Modal>
    <Modal v-model="modal1" footer-hide width="500">
      <div class="model_box">
        <Button class="add_item" size="large" icon="md-add" type="primary" @click="sumbitData">添加pdf</Button>
        <p>上传大文件需要时间，请耐心等待</p>
      </div>
    </Modal>
    <Modal v-model="modal2" footer-hide width="500">
      <Button class="add_item" size="large" icon="md-add" type="primary" @click="addExcel">添加EXCEL</Button>
      <p>上传大文件需要时间，请耐心等待</p>
    </Modal>
    <Modal v-model="modal3" footer-hide width="500">
      <Table border :columns="tableError" :data="error" ref="table"></Table>
    </Modal>
    <Modal v-model="modal4" width="350" title="提示" @on-ok="deleteParper" @on-cancel="cancel">
      <p style="font-size:20px;">确定删除此章节？</p>
    </Modal>
  </div>
</template>
<script>
import { Message } from "iview";
import { dealDate } from "../common/common.js";
import globalData from "../common/Global.js";
import {
  _papersTeachersSheets,
  _paperBookssSheets,
  _papersBooksDotted,
  _papersBooksBoxes,
  _papersBooks,
  _papersBooksBoxesTemplates,
  _papersBooksBoxesDuplicates,
  _papersBooksBoxesPdf,
  _gitPapersBooks,
  _paperBookssSheetsBoxes,
  _deletePapersTeachers,
  _printBooksDotted,
  _cacelDotted,
  _paperSsheetsImages
} from "../api/api.js";
export default {
  data() {
    return {
      radioValue: "每道大题重新排列",
      copyUrl: globalData.positionUrl,
      subjectList: [
        {
          value: "语文",
          label: "语文"
        },
        {
          value: "数学",
          label: "数学"
        },
        {
          value: "英语",
          label: "英语"
        }
      ],
      calssList: [
        {
          value: 1,
          label: "一年级"
        },
        {
          value: 2,
          label: "二年级"
        },
        {
          value: 3,
          label: "三年级"
        },
        {
          value: 4,
          label: "四年级"
        },
        {
          value: 5,
          label: "五年级"
        },
        {
          value: 6,
          label: "六年级"
        },
        {
          value: 7,
          label: "初一"
        },
        {
          value: 8,
          label: "初二"
        },
        {
          value: 9,
          label: "初三"
        }
      ],
      tableError: [
        {
          title: "行号",
          align: "center",
          key: "rowNo"
        },
        {
          title: "错误信息",
          align: "center",
          key: "errorInfo"
        }
      ],
      tables: [
        {
          title: "序号",
          align: "center",
          key: "seqno"
        },
        {
          title: "章节名称",
          align: "center",
          key: "name"
        },
        // {
        //   title: "科目",
        //   align: "center",
        //   key: "subject"
        // },
        // {
        //   title: "年级",
        //   align: "center",
        //   key: "grade"
        // },
        {
          title: "上传时间",
          align: "center",
          key: "createTime"
        },
        {
          title: "文件大小",
          align: "center",
          key: "dotFileSize"
        },
        {
          title: "印刷PDF",
          key: "printFlag",
          align: "center",
          slot: "printFlag"
        },
        {
          title: "打印PDF",
          align: "center",
          render: (h, params) => {
            return h(
              "div",
              {
                on: {
                  click: () => {
                    const { row } = params;
                    switch (row.status) {
                      case 0:
                        break;
                      case 1:
                        break;
                      case 3:
                        break;
                      case 8:
                        break;
                      case 9:
                        break;
                      default:
                        window.open(
                          globalData.positionUrl + "/paper/" + row.dotFile
                        );
                        break;
                    }
                  }
                },
                style: {
                  color: "#2d8cf0",
                  cursor: "pointer"
                }
              },
              (function() {
                switch (params.row.status) {
                  case 0:
                    return "待铺码";
                    break;
                  case 1:
                    return "铺码申请中";
                    break;
                  case 3:
                    return "铺码中";
                    break;
                  case 8:
                    return "铺码中";
                    break;
                  case 9:
                    return "铺码失败";
                    break;
                  default:
                    return "下载";
                    break;
                }
              })()
            );
          }
        },
        {
          title: "校对PDF",
          align: "center",
          width: 130,
          render: (h, params) => {
            switch (params.row.status) {
              case 4:
                const arr = [
                  {
                    text: "生成",
                    fn: () => {
                      console.log("生成");
                      _paperBookssSheetsBoxes(params.row.sheetId).then(res => {
                        if (res.code === 0) {
                          Message.success("成功");
                          this.tableData[params.row.index].boxedFile =
                            res.data.fileName;
                        }
                      });
                    }
                  }
                ];
                if (params.row.boxedFile) {
                  arr.push({
                    text: "下载",
                    fn: () => {
                      console.log("下载");
                      window.open(
                        globalData.positionUrl +
                          "/paper/box/" +
                          params.row.boxedFile
                      );
                    }
                  });
                }
                return h(
                  "div",
                  arr.map(function(item, index) {
                    return h(
                      "span",
                      {
                        style: {
                          marginRight: "20px",
                          color: "#2d8cf0",
                          cursor: "pointer"
                        },
                        on: {
                          click: res => {
                            arr
                              .filter(
                                item => item.text == res.srcElement.innerText
                              )[0]
                              .fn();
                          }
                        }
                      },
                      arr[index].text
                    );
                  })
                );
                break;
              case 5:
                return h("div", {}, "校对PDF中");
                break;
              case 6:
                return h("div", {}, "校对PDF中");
                break;
              default:
                break;
            }
          }
        },
        {
          title: "操作",
          align: "center",
          width: 300,
          render: (h, params) => {
            const arr = [
              {
                title: "删除",
                click: () => {
                  this.modal4 = true;
                  this.selectDeleteId = params.row.sheetId;
                }
              },
              {
                title: "上传图片",
                click: () => {
                  this.paperSsheetsImages(params.row.sheetId);
                }
              },
              {
                title: "题库",
                click: () => {
                  this.$router.push(
                    `/teaching/questionbank?id=${params.row.sheetId}&mode=${params.row.mode}`
                  );
                }
              },
              {
                title: "印刷铺码",
                click: () => {
                  this.printIndex = params.index;
                  this.printBooksDotted();
                }
              },
              {
                title: "取消铺码",
                click: () => {
                  console.log(params.row.id);
                  this.cancalDotted(params.row.sheetId);
                }
              }
            ];
            return h(
              "div",
              arr.map((item, index) => {
                return h(
                  "span",
                  {
                    style: {
                      marginRight: "5px",
                      cursor: "pointer",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: res => {
                        arr[index].click();
                      }
                    }
                  },
                  arr[index].title
                );
              })
            );
          }
        }
      ],
      modal: false,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      id: "",
      name: "",
      selectId: "",
      seqno: "",
      param: "",
      tableData: [],
      error: [],
      printIndex: 0, // 印刷铺码执行index
      page: {
        page: 1,
        current: 1
      }
    };
  },
  methods: {
    ok() {
      try {
        if (!this.seqno) throw "请选择序号";
        if (!this.name) throw "请选择名字";
        this.modal1 = true;
      } catch (error) {
        Message.error(error);
      }
    },
    //下载印刷复制 成功
    onCopySuccess() {
      Message.success("复制成功");
    },
    // 下载印刷复制 失败
    onCopyError() {
      Message.error("复制失败");
    },
    sumbitData() {
      this.$root.$emit("openUploader", data => {
        _paperBookssSheets({
          bookId: this.id,
          uri: data.uri,
          size: data.size,
          name: this.name,
          seqno: this.seqno,
          mode: this.radioValue == "每道大题重新排列" ? 0 : 1
        }).then(res => {
          this.radioValue = "每道大题重新排列";
          this.papersTeachersSheets();
        });
      });
      this.modal1 = false;
    },
    addExcel() {
      console.log(this.selectId);

      this.$root.$emit("openUploader", data => {
        _papersBooksBoxesDuplicates({
          mode: 0,
          uri: data.uri,
          id: this.selectId
        }).then(res => {
          console.log(res);
          if (res.code === 0) {
            if (res.data.errorCount) {
              this.modal3 = true;
              this.error = res.data.items.map(item => {
                return {
                  errorInfo: item.errorInfo,
                  rowNo: item.rowNo
                };
              });
            } else {
              _papersBooksBoxes(this.selectId);
            }
          }
        });
      });
      this.modal2 = false;
    },
    cancel() {},
    papersTeachersSheets() {
      _papersTeachersSheets({
        page: Math.round(this.page.page - 1),
        id: this.id,
        size: 1000
      }).then(res => {
        if (res.code === 0) {
          const { content } = res.data;
          this.page = {
            page: res.data.total / res.data.pageable.size,
            current: res.data.pageable.page + 1
          };
          this.tableData = content.map((item, index) => {
            return {
              name: item.name,
              subject: item.subject,
              createTime: dealDate(item.createTime),
              status: item.status,
              id: item.id,
              dotFile: item.dotFile,
              seqno: item.seqno,
              dotFileSize: item.dotFileSize
                ? (item.dotFileSize / 1024 / 1024).toFixed(2) + "MB"
                : "",
              excelFile: item.excelFile,
              boxedFile: item.boxedFile,
              sheetId: item.sheetId,
              index,
              printFile: item.printFile,
              printFlag: item.printFlag,
              mode: item.mode
            };
          });
        }
      });
    },
    handlePage(e) {
      this.page.page = e;
      this.papersTeachersSheets();
    },
    papersBooksDotted() {
      _papersBooksDotted(this.id).then(res => {
        if (res.code === 0) {
          Message.success("成功");
          this.papersTeachersSheets();
        }
      });
    },
    //上传图片压缩包
    paperSsheetsImages(sheetId) {
      this.$root.$emit("openUploader", data => {
        _paperSsheetsImages({
          sheetId,
          zip: data.uri
        }).then(res => {
          if (res.code === 0) {
            this.$Message.success("上传完成");
          }
        });
      });
    },
    downBoxedFile() {
      window.open(
        globalData.positionUrl + "/paper/box/" + this.param.boxedFile
      );
    }, //教辅生成校对PDF
    papersBooksBoxesPdf() {
      _papersBooksBoxesPdf(this.id).then(res => {
        if (res.code === 0) {
          Message.success("成功");
          this.param.boxedFile = res.data.fileName;
        }
      });
    },
    downPapersBooksDotted() {
      window.open(globalData.positionUrl + "/paper/box/" + this.param.dotFile);
    },
    cancel() {},
    deleteParper() {
      _deletePapersTeachers(this.selectDeleteId).then(res => {
        if (res.code === 0) {
          Message.success("成功");
          this.papersTeachersSheets();
        }
      });
    },

    //印刷铺码
    printBooksDotted(context) {
      const self = this;
      let tag = context ? context : 0;
      if (self.printIndex <= self.tableData.length - 1 && tag === "all") {
        _printBooksDotted(self.tableData[self.printIndex].sheetId).then(res => {
          if (res.code === 0) {
            self.printIndex = self.printIndex / 1 + 1;
            self.printBooksDotted("all");
          } else {
            self.papersTeachersSheets();
            self.printIndex = 0;
          }
        });
      } else if (self.printIndex > self.tableData.length - 1) {
        self.papersTeachersSheets();
        self.printIndex = 0;
      } else {
        _printBooksDotted(self.tableData[self.printIndex].sheetId).then(res => {
          if (res.code === 0) {
            self.papersTeachersSheets();
          } else {
          }
        });
      }
    },
    cancalDotted(id) {
      _cacelDotted(id).then(res => {
        if (res.code == 0) {
          this.$Message.success("已取消");
        }
      });
    }
  },
  created() {
    const param = JSON.parse(this.$route.query.data);
    this.param = param;
    this.id = param.id;
    this.papersTeachersSheets();
  }
};
</script>
<style scoped>
.model_box {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
}

.table {
  margin: 15px 0 25px 0;
}
.ivu-page {
  display: flex;
  justify-content: center;
}
.code-row-bg button {
  margin-left: 20px;
}
.ctrl_btn {
  color: #2d8cf0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Section.vue